const state = {
    type: null,
    output: null,
    // non-blocking notice shown by TheContainer until dismissed (e.g. saved, but an e-mail was not sent)
    warning: null,
    // bumped by every error: FormApiErrors shows only errors raised while it is on screen
    seq: 0
};

const actions = {
    success({ commit }, output) {
        commit('success', output);
    },
    error({ commit }, output) {
        commit('error', output);
    },
    clear({ commit }, output) {
        commit('clear', output);
    },
    warning({ commit }, message) {
        commit('warning', message);
    }
};

const mutations = {
    success(state, output) {
        state.type = 'alert-success';
        state.output = output;
    },
    error(state, output) {
        state.type = 'alert-danger';
        state.output = output;
        state.seq++;
    },
    clear(state, output) {
        state.type = null;
        state.output = output;
    },
    warning(state, message) {
        state.warning = message;
    }
};

export const alert = {
    namespaced: true,
    state,
    actions,
    mutations
};
